export default __webpack_public_path__ + "static/ensdoc-1568c4ac1e94373f58b0c03747d0dfdd.jpg";